import React from 'react';
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import Loader from "../components/Layout/Loader";

const UserProtectedRoute = ({ children }) => {
  const { handle } = useParams();
  const { loading, isAuthenticated, user } = useSelector((state) => state.user);

  if (loading !== false) {
    return <Loader />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (handle && user.handle !== handle) {
    return <Navigate to={`/my-profile/${user.handle}`} replace />;
  }

  return children;
};

export default UserProtectedRoute;


